import {useState} from 'react';

const useTextArea = (props) => {
    const getInitValue = () => {
        if (props.model === 'add') {
            return '';
        }
        if (props.key && props.data) {
            return props.data[props.key] || '';
        }
        return '';
    };
    const [value, setValue] = useState(props.value ? props.value : getInitValue());
    const [valid, setValid] = useState(true);
    const [status, setStatus] = useState('');

    const onChange = (event, _value) => {
        setValue(event.target.value);
        if (props.required) {
            if (!event.target.value || event.target.value.length === 0) {
                setValid(false);
                setStatus('error');
            } else {
                setValid(true);
                setStatus('');
            }
        }

        if (props.onChange) {
            props.onChange(event, _value);
        }
    };

    const checkValid = () => {
        if (props.required && (!value || value.length === 0)) {
            setValid(false);
            setStatus('error');
            return false;
        }
        setValid(true);
        setStatus('');
        return true;
    };

    return {
        props: {
            value,
            onChange,
            status,
        },
        value,
        valid,
        onChange,
        status,
        setStatus,
        checkValid,
    };
};

export default useTextArea;
